// utils/parseCsv.ts
import Papa from "papaparse";
import { Product } from "../types/product";

export const csvToProductMap: Record<string, keyof Product> = {
    URL_Hash: "id",
    BrandName: "brandName",
    Name: "name",
    ProductCategory: "productCategory",
    DigitalFocus: "digitalFocus",
    RegularPrice: "regularPrice",
    RegularDiscount: "regularDiscount",
    PriceSale: "priceSale",
    ShortDescription: "shortDescription",
    ProductDetail: "productDetail",
    ProductImage_New: "productImage",
    Description_New: "description",
    HP_Hash: "hp",
};

export function parseCsvFile(filePath: string): Promise<Product[]> {
    return new Promise((resolve, reject) => {
        fetch(filePath)
            .then((res) => res.text())
            .then((text) => {
                Papa.parse(text, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (result) => {
                        const mappedProducts = result.data.map((row: any) => {
                            const product: Partial<Product> = {};
                            for (const csvCol in csvToProductMap) {
                                const field = csvToProductMap[csvCol];
                                let value = row[csvCol];

                                if (field === "regularPrice" || field === "priceSale" || field === "regularDiscount") {
                                    value =
                                        typeof value === "string" && value.trim() !== ""
                                            ? Number(value.replace(/,/g, ""))
                                            : 0;
                                }

                                if (field === 'productImage') {
                                    value = JSON.parse(value.replace(/'/g, '"'));
                                }

                                product[field] = value;
                            }
                            return product as Product;
                        });
                        resolve(mappedProducts);
                    },
                    error: (err: any) => reject(err),
                });
            });
    });
}
